export const popup = {
    show: show,
    hide: hide
};

function hide(id) {
    var $popup = $("#" + id);

    if ($popup.length === 0) {
        console.log('Unknown popup');
        return;
    }

    if ($popup.hasClass('in')) {
        $('body').removeClass('noscroll');
        $popup.removeClass('in');
    }

    $popup.fadeOut();
}

function show(id) {
    var $popup = $("#" + id);
    if ($popup.length === 0) {
        console.log("Can't show unknown popup");
        return;
    }

    $popup.addClass('in');
    // The display : flex is saved into JQuery's cache so that it is used by fadeIn().
    // https://api.jquery.com/hide/
    // This setup is needed because when defining the popup's base display to flex and style them to display:none by default,
    // it causes problems with Vue.js popups because when they get rebuilt (Ex: you clicked an input) they return to the default display : none.
    $popup.css('display', 'flex').hide().fadeIn();
    $('body').addClass('noscroll');
}

$(document).ready(function () {

    // Opens the popup when clicking on an element with class="popup-opener"
    // The correct popup is targeted by it's ID, which is known to the clicked element with the attribute data-popup="ID", eg : data-popup="poll_popup"
    $(document).on("click", ".popup-opener", function (event) {

        event.preventDefault(); // In case the element is a <a> or would submit a form
        var popupId = $(this).data('popup');

        if (!popupId) { return; }
        popup.show(popupId);
    });


    // Closes the closest popup from the clicked element
    $(document).on("click", ".popup-closer", function (event) {
        event.preventDefault(); // In case the element is a <a> or would submit a form
        $('.popup').each((index, element) => popup.hide($(element).attr('id')));
        //popup.hide($('.popup').attr('id'));
    });

    // Prevent clicks on the popup to bubble up.
    // Un élément qui reçoit un clic le propage par défaut à tous ses parents dans la hiérarchie DOM.
    // La popup, qui a la classe "popup-container", propage les clics reçus à son parent popup-wrapper.
    // Or le wrapper est un "popup-closer", donc un clic dans un élément de la popup entraînerait par défaut sa fermeture.
    // la méthode "stopPropagation()" permet d'éviter ce comportement indésirable ici. 
    $(document).on("click", ".popup-container", function (event) {
        event.stopPropagation();
    });

});